(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"]) return;
  try {
    
(function(){
  function initHello(){
    const dialog=document.querySelector('[data-limetree-hello]');
    if(!dialog||dialog.dataset.ready==='true')return;
    dialog.dataset.ready='true';
    const dismissedKey='limetree-hello-dismissed-until';
    const subscribedKey='limetree-hello-subscribed';
    const success=dialog.querySelector('[data-hello-success]');
    const error=dialog.querySelector('[data-hello-error]');
    const inEditor=window.Shopify&&window.Shopify.designMode;
    const read=(key)=>{try{return localStorage.getItem(key);}catch(e){return null;}};
    const write=(key,value)=>{try{localStorage.setItem(key,value);}catch(e){}};
    const open=()=>{if(!dialog.open&&typeof dialog.showModal==='function')dialog.showModal();};
    const dismiss=()=>{if(dialog.open)dialog.close();};
    dialog.querySelectorAll('[data-hello-close]').forEach(button=>button.addEventListener('click',dismiss));
    dialog.addEventListener('close',()=>{if(dialog.dataset.once==='true')write(dismissedKey,String(Date.now()+604800000));});
    dialog.addEventListener('click',(event)=>{
      if(event.target!==dialog)return;
      const rect=dialog.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dismiss();
    });
    if(success){write(subscribedKey,'true');open();return;}
    if(error||inEditor){open();return;}
    if(read(subscribedKey)==='true')return;
    if(dialog.dataset.once==='true'&&Number(read(dismissedKey)||0)>Date.now())return;
    window.setTimeout(open,Math.max(0,Number(dialog.dataset.delay)||90000));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initHello,{once:true});
  else initHello();
  document.addEventListener('shopify:section:load',initHello);
})();

  } catch(e) { console.error(e); }
})();
})();
